var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYvsnEmblemColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 51,
    viewBox: "0 0 59 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14.7701L29.3416 25.3675H14.6377L0 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14.7701L29.3416 25.3675H14.6377L0 0Z",
    fill: "url(#paint0_linear_42_344)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8468 25.3675L29.2753 51H14.5052L29.3416 25.3675H43.8468Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8468 25.3675L29.2753 51H14.5052L29.3416 25.3675H43.8468Z",
    fill: "url(#paint1_linear_42_344)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8468 25.3675L29.2753 0H58.5507L43.8468 25.3675Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8468 25.3675L29.2753 0H58.5507L43.8468 25.3675Z",
    fill: "url(#paint2_linear_42_344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_344",
    x1: 29.2753,
    y1: 0,
    x2: 29.2753,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_344",
    x1: 29.2753,
    y1: 0,
    x2: 29.2753,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_42_344",
    x1: 29.2753,
    y1: 0,
    x2: 29.2753,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF002E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYvsnEmblemColor);
export default __webpack_public_path__ + "static/media/YVSN_EMBLEM_COLOR.58992034a1421954ebd62488f037b290.svg";
export { ForwardRef as ReactComponent };